/* Launch splash — kept in its own tiny module (no Leaflet/wizard deps) so it stays
   in the initial bundle while the heavy Onboarding wizard is lazy-loaded. */
import React from 'react';
import { Icon } from '../components/ui';

const ROW = { display: 'flex', alignItems: 'center' };
const COL = { display: 'flex', flexDirection: 'column' };
const G1 = 'linear-gradient(160deg, #7A1FA2, #2D0041 70%)';

function Blob({ c, style }) {
  return <span className={`radial-glow ${c}`} style={{ filter: 'blur(70px)', ...style }}></span>;
}

export function Splash({ t, lang, setLang, onDone }) {
  const LANGS = [['en', 'EN'], ['fa', 'فارسی'], ['ru', 'РУС']];
  return (
    <div data-screen-label="Splash" style={{ position: 'absolute', inset: 0, background: 'var(--bg)', overflow: 'hidden', display: 'flex', flexDirection: 'column', zIndex: 80 }}>
      <Blob c="is-purple" style={{ width: 280, height: 280, top: 90, left: -90 }} />
      <Blob c="is-mint" style={{ width: 200, height: 200, bottom: 140, right: -70 }} />
      <Blob c="is-love" style={{ width: 160, height: 160, top: 300, right: -40 }} />

      <div style={{ ...COL, flex: 1, minHeight: 0, alignItems: 'center', justifyContent: 'center', gap: 0, position: 'relative', zIndex: 2, padding: '0 28px' }}>
        <div style={{ position: 'relative', marginBottom: 34 }}>
          <span style={{ width: 96, height: 96, borderRadius: 32, background: G1, boxShadow: 'var(--glow-primary)', border: '1px solid rgba(122,31,162,.5)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <Icon name="heart" size={40} color="var(--accent)" fill="var(--accent)" style={{ filter: 'drop-shadow(0 0 14px rgba(255,212,145,.7))' }} />
          </span>
          <span style={{ position: 'absolute', top: -6, right: -6, width: 14, height: 14, borderRadius: '50%', background: 'var(--accent)', boxShadow: '0 0 16px var(--accent)' }}></span>
        </div>
        <div className="flm-display" style={{ fontSize: 54 }}>FLM</div>
        <div className="flm-mono" style={{ marginTop: 10, color: 'var(--text-2)' }}>{t('splashMonoRow')}</div>
        <p style={{ color: 'var(--text-2)', textAlign: 'center', marginTop: 18, marginBottom: 0, fontSize: 16.5, lineHeight: 1.5, maxWidth: 270 }}>
          {t('splashTagline')}
        </p>
      </div>

      <div style={{ ...COL, gap: 12, padding: '0 22px 18px', position: 'relative', zIndex: 2 }}>
        <button className="flm-cta" onClick={onDone}>
          <Icon name="plane" size={18} fill="currentColor" color="none" />
          {t('obLoginCta')}
        </button>
        <div style={{ ...ROW, justifyContent: 'center', gap: 8 }}>
          <Icon name="shield" size={13} color="var(--text-3)" />
          <span style={{ fontSize: 12.5, color: 'var(--text-3)' }}>{t('splashPrivacy')}</span>
        </div>
        <div style={{ ...ROW, justifyContent: 'center', gap: 14, marginTop: 4, paddingBottom: 6 }}>
          {LANGS.map(([id, label], i) => (
            <React.Fragment key={id}>
              {i > 0 ? <span style={{ width: 3, height: 3, borderRadius: '50%', background: 'var(--border-bright)' }}></span> : null}
              <button className="flm-ghost-btn" onClick={() => setLang(id)} style={{ padding: 2 }}>
                <span className="flm-mono" style={{ fontSize: 9, color: lang === id ? 'var(--accent)' : 'var(--text-3)' }}>{label}</span>
              </button>
            </React.Fragment>
          ))}
        </div>
      </div>
    </div>
  );
}
